import Alpine from 'alpinejs';
import axios from 'axios';
import { createFormValidator } from './formValidator';
import Swal from 'sweetalert2';

window.Alpine = Alpine;
window.axios = axios;

Alpine.store('toast', {
    show({ icon = 'success', title = '', text = '', duration = 3000 }) {
        // Add this back in if we change our minds about the background colour
        // And the stuff in the swal.fire
        // let backgroundColor = '';

        // switch (icon) {
        //     case 'success':
        //         backgroundColor = '#28a745';
        //         break;
        //     case 'error':
        //         backgroundColor = '#dc3545';
        //         break;
        //     case 'warning':
        //         backgroundColor = '#ffc109';
        //         break;
        //     case 'info':
        //         backgroundColor = '#17a2b8';
        //         break;
        //     default:
        //         backgroundColor = '#28a745';
        // }

        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: icon,
            // And this too
            // iconColor: '#fff',
            // color: '#fff',
            // background: backgroundColor,
            title: title,
            text: text,
            showConfirmButton: false,
            timer: duration,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('click', () => {
                    Swal.close();
                });
            }
        });
    }
});

Alpine.store('confirm', {
    async ask({
        title = 'Are you sure?',
        text = '',
        html = '',
        icon = 'warning',
        confirmButtonText = 'Yes',
        cancelButtonText = 'Cancel',
        confirmButtonClass = 'swal2-confirm-btn',
        cancelButtonClass = 'swal2-cancel-btn',
        showCancelButton = true
    }) {
        const result = await Swal.fire({
            title,
            text,
            html,
            icon,
            showCancelButton,
            confirmButtonText,
            cancelButtonText,
            customClass: {
                confirmButton: confirmButtonClass,
                cancelButton: cancelButtonClass
            }
        });

        return result;
    }
});

/**
 * Adds any provided tags as data attributes to the Swal popup element.
 *
 * @param {Object} [tags={}] - An object of key-value pairs to be added as data attributes
 *
 * @example
 * Alpine.store('alert').show({
 *     title: 'Example',
 *     text: 'This is an example',
 *     tags: {
 *         section: 'bar',
 *         location: 'qux'
 *     }
 * });
 *
 * Results in the following HTML:
 * <div class="swal2-popup" data-section="bar" data-location="qux"></div>
 */
const handleAddingTags = (tags = {}) => {
    const element = document.querySelector('.swal2-popup');

    if (Object.keys(tags).length > 0 && element) {
        Object.entries(tags).forEach(([key, value]) => {
            element?.setAttribute(`data-${key}`, value);
        });
    }
};

Alpine.store('alert', {
    show({
        title = '',
        text = '',
        html = '',
        icon,
        confirmButtonText = 'Ok',
        cancelButtonText = 'Cancel',
        confirmButtonClass = 'swal2-confirm-btn',
        cancelButtonClass = 'swal2-cancel-btn',
        showCancelButton = false,
        tags = {},
        callBackForDismissal = () => window.location.reload(true)
    }) {
        Swal.fire({
            title,
            text,
            html,
            icon,
            confirmButtonText,
            showCancelButton,
            cancelButtonText,
            customClass: {
                confirmButton: confirmButtonClass,
                cancelButton: cancelButtonClass
            },
            didOpen: () => handleAddingTags(tags),
            willClose: callBackForDismissal
        });
    }
});

Alpine.store('timed-alert', {
    show({
        title = '',
        text = '',
        icon,
        timer = 2000,
        timerProgressBar = true,
        showConfirmButton = false,
        confirmButtonClass = 'swal2-confirm-btn',
        tags = {},
        // Pass in what you want to do when the alert is closed
        // By default we reload the page
        callBackForDismissal = () => window.location.reload(true)
    }) {
        Swal.fire({
            title,
            text,
            icon,
            timer,
            timerProgressBar,
            showConfirmButton,
            customClass: {
                confirmButton: confirmButtonClass
            },
            willClose: callBackForDismissal,
            didOpen: () => handleAddingTags(tags)
        });
    }
});

const checkForCompanyName = async () => {
    try {
        const formData = new FormData();
        formData.append('action', 'get_company_name');

        const response = await axios.post(ajaxurl, formData);
        return response?.data?.data?.exists ?? undefined;
    } catch (e) {
        console.error('Failed to check for company name');
        console.error(e);
        return undefined;
    }
};

const handleNewEstimateButtonCheck = async () => {
    const hasCompanyName = await checkForCompanyName();

    if (hasCompanyName === undefined) {
        console.error('Recieved undefined for company name in business details modal handler');
        return;
    }

    if (hasCompanyName === false) {
        const modals = document.querySelectorAll('.businessDetailsModal');
        if (!modals || modals.length === 0) {
            console.error('No business details modal found in the dom!');
            return;
        }

        window.dispatchEvent(
            new CustomEvent('bDeetsCheckBtnClick', {
                detail: { hasDetails: hasCompanyName }
            })
        );
        return;
    }

    window.top.location = '/estimates/create';
};

document.querySelectorAll('.bDeetsCheckButton').forEach((el) => {
    el.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await handleNewEstimateButtonCheck();
    });
});

// document.addEventListener('click', async (e) => {
//     if (e.target.closest('.bDeetsCheckButton')) {
//         e.preventDefault();
//         e.stopPropagation();
//         await handleNewEstimateButtonCheck();
//     }
// });

document.addEventListener('alpine:init', () => {
    // Add a global Alpine magic property: $validator
    Alpine.magic('createValidator', ({ el }) => {
        return (form, messages, formEl) => {
            return createFormValidator(form, messages, formEl || el);
        };
    });
});

Alpine.start();
